import { useState } from 'react';
import Lightbox from './Lightbox.jsx';

// Galleries hold up to ~90 photos, so only the first batch is shown and the
// rest load on demand. Everything below the fold is lazily fetched.
const PAGE = 12;

const GalleryFactory = ({ imagesData, title = 'Gallery', lead }) => {
  const [shown, setShown] = useState(PAGE);
  const [openAt, setOpenAt] = useState(null);

  if (!imagesData || !Array.isArray(imagesData.images)) return null;

  const srcs = imagesData.images.map((image) => imagesData.path + image.name);
  const visible = srcs.slice(0, shown);

  return (
    <section className="section" aria-label={title}>
      <div className="container">
        <div className="section-head section-head--center reveal">
          <h2 className="section-title">{title}</h2>
          {lead && <p className="section-lead">{lead}</p>}
        </div>

        <div className="gallery">
          {visible.map((src, i) => (
            <button
              type="button"
              key={src}
              className="gallery__item reveal"
              data-reveal-index={i % 3}
              onClick={() => setOpenAt(i)}
              aria-label={`Open photo ${i + 1}`}
            >
              <img
                src={src}
                alt=""
                loading={i < 6 ? 'eager' : 'lazy'}
                decoding="async"
              />
            </button>
          ))}
        </div>

        {shown < srcs.length && (
          <div className="gallery__more">
            <button
              type="button"
              className="btn"
              onClick={() => setShown((n) => n + PAGE)}
            >
              Load more photos
            </button>
          </div>
        )}
      </div>

      {openAt !== null && (
        <Lightbox
          images={srcs}
          index={openAt}
          onClose={() => setOpenAt(null)}
          onStep={(delta) =>
            setOpenAt((i) => (i + delta + srcs.length) % srcs.length)
          }
        />
      )}
    </section>
  );
};

export default GalleryFactory;
